import React, { useEffect, useState } from 'react';
import styles from './leaseextensionform.module.css';
import { Helmet } from 'react-helmet';
import { Link as Linkto, useHistory } from "react-router-dom";
import Loader from '../../../../components/Loader';
import { Background, Parallax } from "react-parallax";
import dayjs from 'dayjs';
import axios from 'axios';
import { Controller, useForm } from 'react-hook-form';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import NumberFormat from 'react-number-format';

const TenDigitField = React.forwardRef((props, ref) => {
    return <NumberFormat
        customInput={TextField}
        prefix=""
        displayType="input"
        type="text"
        thousandSeparator={false}
        decimalScale={0}
        {...props}
    />;
});

const LeaseExtensionForm = ({ match, props }) => {
    const { str } = match?.params;
    const redirect = useHistory();
    const [loading, setLoading] = useState(false);
    const [propertyDetails, setPropertyDetails] = useState(null);
    const [tenantDetails, setTenantDetails] = useState(null);
    const [isRenew, setIsRenew] = useState('');

    const { handleSubmit, control, formState: { errors } } = useForm({
        mode: "onChange"
    });

    useEffect(() => {
        const fetchByID = async () => {
            await axios.get(process.env.REACT_APP_TENANT_API_URL + 'v1/detail-by-lease-link-token/' + str).then(response => {
                const resData = response.data;
                if (resData?.property && resData?.tenant && resData?.link) {
                    if (resData?.link?.is_expired === 1) {
                        redirect.push('/lease-extension-form-expired/' + str);
                    }
                    setPropertyDetails(resData?.property);
                    setTenantDetails(resData?.tenant);
                } else {
                    redirect.push('/lease-extension-form-invalid');
                }
            }).catch(error => {
                redirect.push('/lease-extension-form-invalid');
            });
        }
        fetchByID();
    }, [str, redirect]);

    const onSubmit = async (data) => {
        let postData = { tenant_id: tenantDetails?.id, link_token: str };
        if (data?.renew_lease === 'Yes') {
            postData = { ...postData, 'names': data?.names, 'no_of_pets': data?.pets, 'renew_lease': 'Yes', 'property': tenantDetails?.property?.name, 'apt_no': tenantDetails?.apartment?.apt_no };
        }

        if (data?.renew_lease === 'No') {
            postData = { ...postData, move_out_date: dayjs(data?.move_out_date).format('MM/DD/YYYY'), 'renew_lease': 'No' };
        }

        setLoading(true);
        await axios.post(process.env.REACT_APP_TENANT_API_URL + 'v1/save-lease-extension-data', postData).then(response => {
            redirect.push('/lease-extension-form-success/' + str);
        }).catch(error => {
            redirect.push('/lease-extension-form-invalid');
        });
    }

    return (<React.Fragment>
        <Helmet title="Lease Extension Form" />
        {loading && <Loader />}

        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
                <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>

        <div className="WhiteBG">

            <div className={`${styles.RentalAppliArea}`}>

                <div className={`${styles.RentalAppliHead}`}>
                    <img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" style={{ width: '200px' }} />
                    <p className={`${styles.RentalAppliHeadTitle}`}>{propertyDetails?.name}</p>
                    <p className={`${styles.RentalAppliHeadTitle}`}>Lease Extension Form</p>
                </div>

                <div className={`${styles.RescheduleSec}`}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={`${styles.AccoFormSec}`}>
                            <div className={`${styles.FormGroupFull} FormGroup CusRental`}>
                                <label className={`${styles.FormLabel}`}>Would you like to renew your lease?<span>*</span></label>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select</InputLabel>
                                    <Controller
                                        name="renew_lease"
                                        control={control}
                                        rules={{ required: 'This field is required.' }}
                                        render={(field) => (
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                onChange={(e) => {
                                                    field.onChange(e);

                                                    setIsRenew(e.target.value);
                                                }}
                                            >
                                                <MenuItem value={'Yes'}>{'Yes'}</MenuItem>
                                                <MenuItem value={'No'}>{'No'}</MenuItem>
                                            </Select>
                                        )}
                                    />
                                    {errors.renew_lease && <p className={`${styles.ErrorM}`}>{errors.renew_lease.message}</p>}
                                </FormControl>
                            </div>

                            {isRenew === 'Yes' && <>
                                <div className={`${styles.FormGroupFull} FormGroup CusRental`}>
                                    <label className={`${styles.FormLabel}`}>What are the names and birthdates for everyone currently living in {tenantDetails?.property?.name} - {tenantDetails?.apartment?.apt_no}?<span>*</span></label>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="names"
                                            control={control}
                                            rules={{
                                                required: "This field is required.",
                                            }}
                                            render={(field) => (
                                                <TextField
                                                    {...field}
                                                    label={"What are the names and birthdates for everyone currently living in " + tenantDetails?.property?.name + " " + tenantDetails?.apartment?.apt_no + "?"}
                                                    multiline
                                                    rows={4}
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors.names && <p className={`${styles.ErrorM}`}>{errors.names.message}</p>}
                                    </FormControl>
                                </div>
                                <div className={`${styles.FormGroupFull} FormGroup CusRental`}>
                                    <label className={`${styles.FormLabel}`}>How many pets do you have?<span>*</span></label>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="pets"
                                            control={control}
                                            rules={{
                                                required: 'This field is required.',
                                                maxLentgh: {
                                                    value: 1,
                                                    message: "Pets field  can not be more than 1 digit."
                                                },
                                            }}
                                            render={(field) => (
                                                <TenDigitField
                                                    {...field}
                                                    format="##"
                                                    label="No. of pets"
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors.pets && <p className={`${styles.ErrorM}`}>{errors.pets.message}</p>}
                                    </FormControl>
                                </div>
                            </>}
                            {isRenew === 'No' && <div className={`${styles.FormGroupFull} FormGroup CusRental`}>
                                <label className={`${styles.FormLabel}`}>Select Move-out Date<span>*</span></label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Controller
                                        name="move_out_date"
                                        control={control}
                                        rules={{ required: 'This field is required.' }}
                                        render={(field) => (<DatePicker
                                            {...field}
                                            renderInput={(params) => (
                                                <TextField {...params} />
                                            )}
                                            onChange={(e) => {
                                                field.onChange(e);
                                            }}
                                        />)}
                                    />
                                </LocalizationProvider>
                                {errors.move_out_date && <p className={`${styles.ErrorM}`}>This field is required</p>}
                            </div>}

                            <div className={`${styles.AccoFormBUsec}`}>
                                <button type="submit" className={`${styles.applicantNextBU}`}>Complete</button>
                            </div>

                        </div>
                    </form>
                </div>

            </div>

            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src={(propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url !== '') ? propertyDetails?.app_theme_options?.image_url : '/static/img/logo.svg'} alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: ${propertyDetails?.email}`}>{propertyDetails?.email}</a></li>
                                <li><a href={`tel: ${propertyDetails?.phone}`} >{propertyDetails?.phone}</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>{propertyDetails?.address} <br />{propertyDetails?.city}, {propertyDetails?.state} {propertyDetails?.zip}</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>{propertyDetails?.name} © {dayjs().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </React.Fragment>)
}

export default LeaseExtensionForm;